import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { MovementTable } from "@/components/MovementTable";

export default function History() {
  const [q, setQ] = useState("");
  const [moves, setMoves] = useState([]);

  useEffect(() => {
    const t = setTimeout(() => api.get("/moves", { params: { q } }).then((r) => setMoves(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8 sm:py-12">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-3">Audit trail</p>
      <h2 className="font-serif text-4xl sm:text-5xl text-[#F5F0EB] mb-8">Movements</h2>
      <div className="relative mb-6 max-w-lg">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6E665D]" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by code, wine, location or person" className="pl-10 h-11 bg-[#161214]" data-testid="history-search-input" />
      </div>
      <MovementTable moves={moves} />
    </div>
  );
}
